"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskRatioDashboardWidget = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@veeam/core");
const Snapshot32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Snapshot32.svg"));
const Replica_snapshots32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Replica_snapshots32.svg"));
const Backup32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Backup32.svg"));
const Archive32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Archive32.svg"));
const components_1 = require("../../../../components");
const core_2 = require("../../../../core");
const components_2 = require("../../components");
const TaskRatioInteractor_1 = require("./TaskRatioInteractor");
const types_1 = require("./types");
const components_3 = require("../../../../components/DashboardWidgets/components");
const helpers_1 = require("../../../../components/DashboardWidgets/helpers");
const constants_1 = require("../constants");
const TaskRatioDashboardWidget = ({ loadableModel, onRowClick, noDataTexts, }) => {
    const { t } = core_2.useFeatureContext();
    const [periodModel] = react_1.useState(() => new components_2.PeriodModel());
    core_1.useInteractor(() => {
        return new TaskRatioInteractor_1.TaskRatioInteractor(loadableModel, periodModel, constants_1.WIDGET_NAMES.taskRatio);
    });
    const { value, meta: { loading: isLoading }, } = core_1.useModel(loadableModel);
    const { value: periodValue } = core_1.useModel(periodModel);
    const widgetData = [
        {
            type: types_1.TASK_RATIO_WIDGET_ROW_TYPES.snapshot,
            icon: Snapshot32_svg_1.default,
            text: t('dashboard|taskRatio|jobType|snapshots'),
            value: value.snapshotsCount,
            total: value.snapshotsTotalCount,
        },
        {
            type: types_1.TASK_RATIO_WIDGET_ROW_TYPES.backup,
            icon: Backup32_svg_1.default,
            text: t('dashboard|taskRatio|jobType|backups'),
            value: value.backupsCount,
            total: value.backupsTotalCount,
        },
        {
            type: types_1.TASK_RATIO_WIDGET_ROW_TYPES.archive,
            icon: Archive32_svg_1.default,
            text: t('dashboard|taskRatio|jobType|archives'),
            value: value.archivesCount,
            total: value.archivesTotalCount,
        },
    ];
    if (typeof value.replicasCount === 'number' && typeof value.replicasTotalCount === 'number') {
        widgetData.splice(1, 0, {
            type: types_1.TASK_RATIO_WIDGET_ROW_TYPES.replica,
            icon: Replica_snapshots32_svg_1.default,
            text: t('dashboard|taskRatio|jobType|replicaSnapshots'),
            value: value.replicasCount,
            total: value.replicasTotalCount,
        });
    }
    return (react_1.default.createElement(components_1.DashboardPlate, { title: t('dashboard|taskRatio|header'), headerAddon: !isLoading ? react_1.default.createElement(components_2.Period, { model: periodModel }) : undefined, content: react_1.default.createElement(components_1.TableWidget, { isLoading: isLoading, isShrink: widgetData.length <= 3, rows: widgetData.map((data) => ({
                id: `${data.text}Row`,
                content: (react_1.default.createElement(components_3.IconTextAndChartRow, { height: helpers_1.getRowHeight(widgetData.length), icon: data.icon, text: data.text, value: data.value, total: data.total, noDataText: noDataTexts[data.type] })),
                onClick: onRowClick ? () => onRowClick(data.type, periodValue.id) : undefined,
            })) }) }));
};
exports.TaskRatioDashboardWidget = TaskRatioDashboardWidget;
//# sourceMappingURL=TaskRatioDashboardWidget.js.map